var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStudio = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 13,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.903,
  d: "M7.223 7.523H3.512m1.905-2.006H3.512m7.021 2.507c0 .831-.673 1.505-1.504 1.505H3.01a1.505 1.505 0 0 1-1.505-1.505V4.012c0-.831.674-1.505 1.505-1.505h3.51"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 0.903,
  d: "M9.776 1.88a3.01 3.01 0 0 1 0 4.257M8.358 3.299a1.003 1.003 0 0 1 0 1.419"
})));
export default SvgStudio;